export default "__VITE_ASSET__DyazMt4R__"